import script from "./templateEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./templateEditor.vue?vue&type=script&setup=true&lang=ts"

import "./templateEditor.vue?vue&type=style&index=0&id=20a9181c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a9181c"]])

export default __exports__